<template>
    <div>
        <Header title="审核订单">
        </Header>
        <div class="my-white-mod">
            <div style="margin-bottom:10px">
                <Input prefix="ios-search" v-model="search_id" placeholder="请输入单号" style="width:200px;"></Input>
                <Select v-model="search_model" style="width:150px;margin-left:10px" clearable >
                    <Option v-for="item in models" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
                <Select style="width:187px;margin-left:10px" placeholder="请选择成交方式" v-model="search_type" filterable clearable >
                    <Option v-for="item in transaction_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
                <TagScreen @changeTags="changeTag"  @changeTagsId="changeTagId" ></TagScreen>
            </div>
            <div>
                <DatePicker type="daterange" placement="bottom-end" placeholder="选择成交时间" style="width: 200px;"  @on-change="change_date"></DatePicker>
                <DatePicker type="daterange" placement="bottom-end" placeholder="选择交付时间" style="width: 200px;margin-left:10px"  @on-change="change_jiaofu_date"></DatePicker>

                <Button  @click="searchList" type="warning" style="margin-left:10px">搜索</Button>
                <Button  @click="ok_export" v-if="userInfo.role == 0 " type="success" style="margin-left:10px">导出</Button>
            </div>
        </div>
        <div class="my-white-mod">
            <Button :disabled="order_ids.length == 0" @click="examine_order(1)" type="success" >批量审核</Button>
            <Table  :row-class-name="rowClassName" :loading="table.loading"  @on-selection-change="selectChange"   :columns="table.columns" :data="table.data"></Table>
            <Page :total="table.total" :current="table.current" :page-size="table.limit" @on-change="changepage" show-elevator show-total style="margin-top:10px;text-align: right"  />
        </div>

        <Modal
                v-model="show_refund"
                title="退款记录"
                width="800"
                :mask-closable="false"
        >
            <PageTable  :loading="refund_table.loading" :size="refund_table.limit" :columns="refund_table.columns" :data="refund_table.data" :current="refund_table.current" :total="refund_table.total" @switchPage="change_refund"  >
            </PageTable>
            <div slot="footer"></div>
        </Modal>


        <Modal
                v-model="show_error"
                title="错误通知记录"
                width="600"
                :mask-closable="false"
        >
            <Button  @click="add_error" >新增通知</Button>
            <PageTable  :loading="error_table.loading" :size="error_table.limit" :columns="error_table.columns" :data="error_table.data" :current="error_table.current" :total="error_table.total" @switchPage="change_error"  >
            </PageTable>
            <div slot="footer"></div>
        </Modal>

        <Modal
                v-model="show_ok_refund"
                title="退款"
                :mask-closable="false"
                width="400"
        >
            <div>申请退款金额</div>
            <Input  disabled v-model="formRefund.money" type="text"  />
            <div style="margin-top: 10px">真实退款金额</div>
            <Input placeholder="请输入退款金额" v-model="formRefund.refund_money" type="text"  />
            <div slot="footer">
                <Button  type="primary"  @click="ok_refund">确定</Button >
            </div>
        </Modal>
    </div>

</template>
<script>
    import { follow_record_list, get_transaction} from "@/api/customer"
    import {order_success_list, after_history, order_examine, order_error, order_refund_list, del_refund, order_back_refuse, export_success_list, order_error_list} from "@/api/order"
    import {Header, PageTable, TagScreen } from "@/components/mainLayout"
    import {copyText} from "@/utils/helper";
    export default {
        components:{
            Header,
            PageTable,
            TagScreen
        },
        data(){
            return{
                jiaofu_start_date:"",
                jiaofu_end_date:"",
                show_refund:false,
                show_ok_refund:false,
                show_error:false,
                screen_tags_text:"",
                screen_tags_id:"",
                formRefund:{
                    moeny:0,
                    order_id:0,
                    refund_money:0,
                    reason:""
                },
                commit:0,
                tags_active:[],
                models:[
                    {id:2, name:'所有'},
                    {id:1, name:'已审核'},
                    {id:0, name:'未审核'}
                ],
                start_date:"",
                search_type:"",
                end_date:"",
                transaction_list:[],
                order_ids:[],
                search_model:2,
                customer_loading:false,
                show_infos:false,
                customer_id:"",
                order_id:0,
                order_delivery_status:0,
                search_id:"",
                table:{
                    loading:false,
                    current:1,
                    total:0,
                    limit:30,
                    columns: [
                        {
                            type: 'selection',
                            width: 40,
                            align: 'center'
                        },
                        {
                            title: '单号',
                            width:'100',
                            align:'center',
                            key: 'id',
                            render: (h, params) => {
                               let tpl = `<div >`+params.row.id +`</div>`;
                               if (params.row.delivery_status != 1 && params.row.delivery_status != 9) {
                                    tpl += `<div >尚未交付</div>`
                                }
                               if (params.row.delivery_status == 9) {
                                    tpl += `<div >停止对接</div>`
                                }
                                if (params.row.most_retainage_id) {
                                    tpl += `<div >尾款主单${params.row.most_retainage_id}</div>`
                                }
                                return h("div", {
                                    domProps:{
                                        innerHTML:tpl
                                    }
                                })

                            }
                        },
                        {
                            title: '订单编号',
                            width:'100',
                            align:'center',
                            key: 'order_number'
                        },
                        {
                            title: '客户',
                            align:'center',
                            key: 'name',
                            width:260,
                            render: (h, params) => {
                                let male = require("../../assets/11.png");
                                let female = require("../../assets/12.png");
                                let default_img = require("../../assets/3.png");
                                if (params.row.avatar != null && params.row.avatar != "") {
                                    default_img = params.row.avatar
                                }
                                let default_ = female;
                                if (params.row.gender == 1) {
                                    default_ = male;
                                }
                                if (params.row.is_big == 1) {
                                    var default_big = require("@/assets/is_big.png");
                                }
                                return h("div", {
                                    domProps:{
                                        innerHTML:`<div style="text-align: left;padding-bottom:5px;cursor:pointer"><div style="display: flex;padding:10px 0 5px;height: 70px">`+
                                            `<img src=`+default_img+` style="width:50px;height:50px;">` +
                                            `<div style="margin-left:10px;flex:1;text-align: left;">` +
                                                `<div>`+(params.row.remark || params.row.customer_name)+`</div>`+
                                                `<div><img src=`+default_+` style="width:20px;height:20px;"><img src=`+default_big+` style="width:32px;height:10.5px;">`+`</div>`+
                                            `</div>` +
                                            `</div>`+
                                            `企微群：`+ (params.row.qq_group ? params.row.qq_group :"无")+
                                            `</div>`
                                    },
                                    on:{
                                        click:()=>{
                                            copyText(params.row.remark || params.row.customer_name)
                                        }
                                    }
                                })

                            }
                        },
                        {
                            title: '标签',
                            align:'center',
                            key: 'id',
                            width:200,
                            render: (h, params) => {
                                let tpl = "", tag_name = params.row.tag_name;
                                if (tag_name && tag_name.length > 0) {
                                    for(let i in tag_name) {
                                        tpl += `<div><div  class="tag-class">`+tag_name[i]+`</div></div>`;
                                    }
                                } else {
                                    tpl += `<div class="tag-dotted">尚未设置</div>`;
                                }
                                return h("div", {
                                    domProps:{
                                        innerHTML:`<div style="display:flex;flex-wrap:wrap;padding:10px 0 5px">`+
                                            tpl +
                                            `</div>`
                                    }
                                })

                            }
                        },
                        {
                            title: '成交金额',
                            align:'center',
                            width:120,
                            key: 'pay_money',
                            render: (h, params) => {
                                let refund_text = params.row.refund_count_success > 0 ? "<div style='color:#ff0000;font-weight:600' >退款￥"+params.row.refund_money+"</div>":""
                                return h("div", {
                                    domProps:{
                                        innerHTML:`<div >`+params.row.pay_money +`</div>`
                                                +`<div >`+ (params.row.retainage_status == 0 ? "<span style='color:#f90'>尾款￥"+params.row.retainage+"</span>" :"" ) +`</div>`+refund_text
                                    }
                                })

                            }
                        },
                        {
                            title: '成交方式',
                            align:'center',
                            width:100,
                            key: 'pay_type_name'
                        },{
                            title: '成交日期',
                            align:'center',
                            width:180,
                            render: (h, params) => {
                                return h('div', [
                                    h('span', {
                                        style:{color:'#445E87'}
                                    }, params.row.pay_time.replace("T", " "))
                                ]);
                            }
                        },
                        {
                            title: '跟进员工',
                            align:'center',
                            key: 'department_member_name',
                            width:200
                        },
                        {
                            title: '售后员工',
                            align:'center',
                            key: 'after_name',
                            width:200
                        },
                        {
                            title: '交付时间',
                            align:'center',
                            key: 'delivery_time',
                            width:200,
                            render: (h, params) => {
                                return h('div', [
                                    h('span', {
                                        style:{color:'#445E87'}
                                    }, params.row.delivery_time? params.row.delivery_time.replace("T", " ") :"")
                                ]);
                            }
                        },
                        {
                            title: '创建时间',
                            align:'center',
                            width:180,
                            key: 'ctime'
                        }
                        ,{
                            title: '操作',
                            align:'center',
                            key: 'id',
                            fixed: 'right',
                            width:150,
                            render: (h, params) => {
                                let btnArr = []
                                let lookbtn = h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{color:'#3F8CFF'},
                                    on: {
                                        click: () => {
                                            this.$router.push({
                                                path: '/customerpool/info',
                                                query: {
                                                    order_id: params.row.id,
                                                    customer_id:params.row.customerId,
                                                    type:6
                                                }
                                            });
                                        }
                                    }
                                }, '详情')

                                let examinebtn = h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{color:'#FF0000'},
                                    on: {
                                        click: () => {
                                            this.order_ids = []
                                            this.order_ids.push(params.row.id)
                                            this.examine_order(0)
                                        }
                                    }
                                }, '审核')

                                let refund_text = params.row.refund_count == 0? "退款" :'退款('+params.row.refund_count+")"
                                let refundbtn = h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{color:'#ff0000'},
                                    on: {
                                        click: () => {
                                            this.order_id = params.row.id;
                                            this.show_refund = true;
                                            this.refund_list()
                                        }
                                    }
                                }, refund_text)
                                let error_text = params.row.errors_tips_count == 0? "错误通知" : '错误通知('+params.row.errors_tips_count+")"
                                let errorbtn = h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{color:'#000000'},
                                    on: {
                                        click: () => {
                                            this.order_ids = []
                                            this.order_ids.push(params.row.id)
                                            this.error_list()
                                            this.show_error = true;
                                        }
                                    }
                                }, error_text)
                                let backbtn = h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{color:'#000000'},
                                    on: {
                                        click: () => {
                                            this.order_ids = []
                                            this.order_ids.push(params.row.id)
                                            this.back_examine_order(0)
                                        }
                                    }
                                }, '回撤审核')

                                btnArr.push(lookbtn)
                                if (params.row.is_examine == 1) {
                                    btnArr.push(backbtn)
                                } else {
                                    btnArr.push(examinebtn)
                                    btnArr.push(errorbtn)
                                }
                                btnArr.push(refundbtn)

                                return h('div', btnArr);

                            }

                        }
                    ],
                    data: [],
                    default_cid:0,
                    search_customer:""
                },
                refund_table: {
                    loading:false,
                    current: 1,
                    total: 0,
                    limit: 30,
                    columns: [
                        {
                            type:'index',
                            width:'80',
                            align:'center'
                        },{
                            title: '申请时间',
                            align:'center',
                            width:'170',
                            key: 'ctime',
                            render: (h, params) => {
                                return h('div', [
                                    h('span', {
                                        style:{color:'#445E87'}
                                    }, params.row.ctime.replace("T", " "))
                                ]);
                            }
                        },{
                            title: '状态',
                            align:'center',
                            width:'100',
                            key: 'ctime',
                            render: (h, params) => {
                                let text = params.row.refund_status == 0 ? "待审核" : params.row.refund_status == 1 ? "已通过" :"被拒绝"


                                let color = params.row.refund_status == 0 ? "#445E87" : params.row.refund_status == 1 ? "#4caf50" :"#ff0000"
                                return h('div', [
                                    h('span', {
                                        style:{color:color}
                                    }, text)
                                ]);
                            }
                        },{
                            title: '申请金额',
                            align:'center',
                            width:'120',
                            key: 'money'
                        },{
                            title: '退款金额',
                            align:'center',
                            width:'120',
                            key: 'refund_money'
                        },{
                            title: '审核时间',
                            align:'center',
                            width:'170',
                            key: 'refund_time',
                            render: (h, params) => {
                                return h('div', [
                                    h('span', {
                                        style:{color:'#445E87'}
                                    }, params.row.refund_time ? params.row.refund_time.replace("T", " ") : "")
                                ]);
                            }
                        },{
                            title: '拒绝原因',
                            align:'center',
                            width:'170',
                            key: 'reason',
                            render: (h, params) => {
                                return h('Input',{
                                    props: {
                                        value:params.row.reason,
                                        type:'textarea'
                                    }
                                })
                            }
                        },{
                            title: '操作',
                            align:'center',
                            key: 'id',
                            fixed: 'right',
                            width:140,
                            render: (h, params) => {
                                let btnArr = []
                                3
                                let okBtn = h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{color:'#3F8CFF',cursor:'pointer'},
                                    on: {
                                        click: () => {
                                            this.formRefund.status = 1;
                                            this.formRefund.id = params.row.id
                                            this.formRefund.money = params.row.money
                                            this.formRefund.refund_money = params.row.money
                                            this.show_ok_refund = true
                                        }
                                    }
                                }, '同意')
                                let refuseBtn = h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{color:'#ff0000',cursor:'pointer'},
                                    on: {
                                        click: () => {
                                            this.formRefund.status = 2;
                                            this.formRefund.id = params.row.id
                                            this.formRefund.refund_money = 0
                                            this.refuse_refund_order(params.row.id)
                                        }
                                    }
                                }, '拒绝')

                                let backbtn = h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{color:'#000000'},
                                    on: {
                                        click: () => {
                                            this.formRefund.id = params.row.id
                                            this.back_refuse_order(0)
                                        }
                                    }
                                }, '回撤')

                                if (params.row.refund_status == 0) {
                                    btnArr.push(okBtn)
                                    btnArr.push(refuseBtn)
                                }
                                if (params.row.refund_status != 0) {
                                    btnArr.push(backbtn)
                                }

                                return h('div', btnArr);

                            }

                        }],
                    data:[]
                },
                error_table: {
                    loading:false,
                    current: 1,
                    total: 0,
                    limit: 30,
                    columns: [
                        {
                            type:'index',
                            width:'80',
                            align:'center'
                        },{
                            title: '通知时间',
                            align:'center',
                            width:'170',
                            key: 'ctime',
                            render: (h, params) => {
                                return h('div', [
                                    h('span', {
                                        style:{color:'#445E87'}
                                    }, params.row.ctime.replace("T", " "))
                                ]);
                            }
                        },{
                            title: '通知内容',
                            align:'center',
                            width:'300',
                            key: 'reason',
                            render: (h, params) => {
                                return h('Input',{
                                    props: {
                                        value:params.row.reason,
                                        type:'textarea',
                                        size:'small'
                                    }
                                })
                            }
                        }],
                    data:[]
                },
                userInfo:{},

            }
        },
        mounted(){
            this.userInfo = this.$store.state.userInfo
            this.getList();
            this.get_transaction_list()
        },
        methods:{
            add_error(){
                this.error_order(0)
            },
            searchList(){
                this.table.current = 1
                this.getList()
            },
            ok_export(){

                if (this.commit == 1) {
                    return
                }
                let val = {};
                if(this.search_id != "") {
                    val.search_id = this.search_id
                }
                if(this.search_type !="") {
                    val.search_type = this.search_type
                }
                if(this.start_date != "") {
                    val.start_date = this.start_date
                }
                if(this.end_date != "") {
                    val.end_date = this.end_date
                }

                
                if(this.jiaofu_start_date != "") {
                    val.jiaofu_start_date = this.jiaofu_start_date
                }
                if(this.jiaofu_end_date != "") {
                    val.jiaofu_end_date = this.jiaofu_end_date
                }
                if(this.search_model !== "") {
                    val.search_model = this.search_model
                }

                if (this.screen_tags_text != "")  {
                    val.screen_tags_text = this.screen_tags_text
                }
                if (this.screen_tags_id != "")  {
                    val.screen_tags_id = this.screen_tags_id
                }
                this.$Message.info({
                    content: '处理数据中，请等待',
                    duration: 0
                });
                this.commit = 1;
                let _this = this
                export_success_list(val).then(res=>{
                    this.$Message.destroy()
                    if(res.code == 200) {
                        let url = res.data
                        if (navigator.userAgent.indexOf("Safari") > -1) {
                            const newPage = window.open("newPage", "_blank");
                            newPage.location = url;
                        } else {
                            window.open(url, "_blank").location;
                        }
                    } else {
                        this.$Message.error(res.msg);
                    }
                    setTimeout(function(){
                        _this.commit = 0;
                    }, 500)
                }).catch(err=>{
                    this.$Message.destroy()
                    setTimeout(function(){
                        _this.commit = 0;
                    }, 500)
                })
            },
            closeWindowEvent() {
                if (navigator.userAgent.indexOf("Firefox") != -1 || navigator.userAgent.indexOf("Chrome") != -1) {
                    window.opener = null;
                    window.open("", "_self", "");
                    window.location.href = "about:blank";
                    window.close();
                } else {
                    window.opener = null;
                    window.open("", "_self", "");
                    window.location.href = "about:blank";
                    window.close();
                }
            },
            history_list(){
                this.history_table.loading = true;
                after_history({limit:this.history_table.limit, page:this.history_table.current, order_id:this.order_id}).then(res=>{
                    this.history_table.loading = false;
                    if(res.code == 200) {
                        this.history_table.data = res.data;
                        this.history_table.total = res.total;
                    } else {
                        this.history_table.data = [];
                        this.history_table.total = 0;
                        this.$Message.error(res.msg)
                    }
                })
            },
            get_transaction_list(){
                get_transaction().then(res=>{
                    if(res.code == 200) {
                        this.transaction_list = res.data
                    }
                })
            },
            selectChange(e){
                this.order_ids = [];
                for (let i in e) {
                    this.order_ids.push(e[i].id)
                }
            },
            change_date(e){
                this.start_date = e[0]
                this.end_date = e[1]
            },
            change_jiaofu_date(e){
                this.jiaofu_start_date = e[0]
                this.jiaofu_end_date = e[1]
            },
            examine_order(e){
                let text = e == 0? '确认此订单已审核通过？' : '确认批量处理这些订单？'
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>'+text+'</p>',
                    onOk: () => {
                        order_examine({order_id:this.order_ids, type:1}).then(res=>{
                            if (res.code == 200) {
                                this.getList()
                                this.$Message.success(res.msg);
                            } else {
                                this.$Message.error(res.msg)
                            }
                        })
                    }
                });
            },
            back_examine_order(e){
                let text = e == 0? '确认撤销此订单的审核状态？' : '确认批量撤销这些订单的审核状态？'
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>'+text+'</p>',
                    onOk: () => {
                        order_examine({order_id:this.order_ids, type:0}).then(res=>{
                            if (res.code == 200) {
                                this.getList()
                                this.$Message.success(res.msg);
                            } else {
                                this.$Message.error(res.msg)
                            }
                        })
                    }
                });
            },

            error_order(e){
                let reason = ""
                let text = e == 0? '是否确认通知销售订单数据错误？' : '是否确认批量通知销售订单数据错误？'
                this.$Modal.confirm({
                    title: '<p>'+text+'</p>',
                    onOk: () => {

                        if (reason == "" || reason == undefined) {
                            this.$Message.error("请输入错误原因");return
                        }

                        order_error({order_id:this.order_ids, reason:reason}).then(res=>{
                            if (res.code == 200) {
                                this.getList()
                                this.error_list()
                                this.$Message.success(res.msg);
                            } else {
                                this.$Message.error(res.msg)
                            }
                        })
                    },
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: this.value,
                                autofocus: true,
                                placeholder: '请输入错误原因',
                                type:'textarea'
                            },
                            on: {
                                input: (val) => {
                                    reason = val;
                                }
                            }
                        })
                    }
                })

            },
            getList(){

                let val = {limit:this.table.limit, page:this.table.current};
                if(this.search_id != "") {
                    val.search_id = this.search_id
                }
                if(this.search_type !="") {
                    val.search_type = this.search_type
                }
                if(this.start_date != "") {
                    val.start_date = this.start_date
                }
                if(this.end_date != "") {
                    val.end_date = this.end_date
                }
                if(this.jiaofu_start_date != "") {
                    val.jiaofu_start_date = this.jiaofu_start_date
                }
                if(this.jiaofu_end_date != "") {
                    val.jiaofu_end_date = this.jiaofu_end_date
                }

                
                if(this.search_model !== "") {
                    val.search_model = this.search_model
                }

                if (this.screen_tags_id != "")  {
                    val.screen_tags_id = this.screen_tags_id
                }
                this.table.loading = true;
                order_success_list(val).then(res=>{
                    this.table.loading = false;
                    if(res.code == 200) {
                        this.table.data = res.data;
                        this.table.total = res.total;
                    } else {
                        this.table.data = [];
                        this.table.total = 0;
                        this.$Message.error(res.msg);
                    }
                })
            },

            changeTag(e){
                this.screen_tags_text = e;
            },
            changeTagId(e){
                this.screen_tags_id = e;
            },
            changepage(e){
                this.table.current = e;
                this.getList();
            },
            changeDate(e){
                this.successSubmit.expiration_date = e;
            },

            rowClassName (row, index) {
                if (row.is_examine === 1) {
                    return 'demo-table-info-row';
                }
                return '';
            },


            change_refund(e){
                this.refund_table.current = e;
                this.refund_list();
            },

            change_error(e){
                this.error_table.current = e;
                this.error_list();
            },
            error_list(){
                this.error_table.loading = true;
                order_error_list({order_ids:this.order_ids, limit:this.error_table.limit, page:this.error_table.current}).then(res=>{
                    this.error_table.loading = false;
                    if (res.code == 200) {
                        this.error_table.data = res.data;
                        this.error_table.total = res.total;
                    } else {
                        this.error_table.data = [];
                        this.error_table.total = 0;
                        this.$Message.error(res.msg);
                    }
                })
            },
            refund_list(){
                this.refund_table.loading = true;
                order_refund_list({order_id:this.order_id, limit:this.refund_table.limit, page:this.refund_table.current}).then(res=>{
                    this.refund_table.loading = false;
                    if (res.code == 200) {
                        this.refund_table.data = res.data;
                        this.refund_table.total = res.total;
                    } else {
                        this.refund_table.data = [];
                        this.refund_table.total = 0;
                        this.$Message.error(res.msg);
                    }
                })
            },
            ok_refund(){

                if (this.commit == 1) {
                    return
                }
                if ( this.formRefund.status == 1&& (this.formRefund.refund_money == "" || this.formRefund.refund_money == 0)) {
                    this.$Message.error("请输入真实退款金额");return
                }
                this.$Message.info({
                    content: '提交中',
                    duration: 0
                });
                this.commit = 1;
                let _this = this
                del_refund(this.formRefund).then(res=>{
                    this.$Message.destroy()
                    if (res.code == 200) {
                        this.refund_list()
                        this.show_ok_refund = false;
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                    setTimeout(function(){
                        _this.commit = 0;
                    }, 500)
                })
            },

            back_refuse_order(e){
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>确认将此订单回撤为待审核状态？</p>',
                    onOk: () => {
                        order_back_refuse(this.formRefund).then(res=>{
                            if (res.code == 200) {
                                this.refund_list()
                                this.$Message.success(res.msg);
                            } else {
                                this.$Message.error(res.msg)
                            }
                        })
                    }
                });
            },
            refuse_refund_order(){
                this.$Modal.confirm({
                    title: '<p>请输入拒绝原因</p>',
                    onOk: () => {

                        if (this.formRefund.reason == "" || this.formRefund.reason == undefined) {
                            this.$Message.error("请输入拒绝原因");return
                        }
                        this.ok_refund()
                    },
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: this.value,
                                autofocus: true,
                                placeholder: '请输入拒绝原因',
                                type:'textarea'
                            },
                            on: {
                                input: (val) => {
                                    this.formRefund.reason = val;
                                }
                            }
                        })
                    }
                })
            }
        }
    }
</script>
<style scoped>

    >>>.tag-class{
        width: 90%;
        padding:5px 10px;
        border:1px solid #ddd;
        border-radius: 5px;
        margin:2px 5px;
        background: #ffffff;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
    }
    >>>.tag-dotted{

        width: 90%;
        padding:5px 10px;
        border:1px dotted #ddd;
        border-radius: 5px;
        margin:2px 5px;
    }

    >>>#add_customer .ivu-select-dropdown-list .ivu-select-item{
        height:50px
    }
    >>>.ivu-table .demo-table-info-row td{
        background-color: #4caf50;
        color: #fff;
    }
    >>>.ivu-table .demo-table-info-row td .tag-class{
        color: #000000!important;
    }
    >>>.ivu-table .demo-table-info-row td .ivu-btn-text{
        color: #ffffff!important;
    }
    >>>.ivu-modal .ivu-btn-text{
        display: inline-block;
    }

</style>
